import { useMemo, useCallback } from 'react';
import '../../utils/responsive.es.js';
import 'body-scroll-lock';
import '../../hooks/useNotification/useNotification.es.js';
import '../../hooks/useToast/useToast.es.js';
import '@popperjs/core';
import '../../utils/assertions.es.js';
import '../../utils/scrollIntoView.es.js';
import 'polished';
import '@styled-system/css';
import 'styled-components';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import 'react-beautiful-dnd';
import 'use-callback-ref';
import { useControlled } from '../../hooks/useControlled/useControlled.es.js';
import 'nanoid/non-secure';
import { getPositionFromValue, getValueFromPosition } from './helpers.es.js';

const useSlider = (props) => {
  const { min, max, width = 300, onChange, onChangeEnd, defaultValue, value } = props;
  const [currentValue, updateValue] = useControlled({
    defaultValue: defaultValue != null ? defaultValue : { min, max },
    value,
    onChange
  });
  const positions = useMemo(() => {
    var _a, _b;
    return {
      min: getPositionFromValue((_a = currentValue == null ? void 0 : currentValue.min) != null ? _a : min, min, max, width),
      max: getPositionFromValue((_b = currentValue == null ? void 0 : currentValue.max) != null ? _b : max, min, max, width)
    };
  }, [currentValue, min, max, width]);
  const updateMinFromPosition = useCallback((position) => {
    var _a;
    const minPosition2 = getValueFromPosition(position, min, max, width);
    updateValue({ min: minPosition2, max: (_a = currentValue == null ? void 0 : currentValue.max) != null ? _a : max });
  }, [min, max, currentValue, updateValue, width]);
  const updateMaxFromPosition = useCallback((position) => {
    var _a;
    const maxPosition2 = getValueFromPosition(position, min, max, width);
    updateValue({ min: (_a = currentValue == null ? void 0 : currentValue.min) != null ? _a : min, max: maxPosition2 });
  }, [min, max, currentValue, updateValue, width]);
  const onMinChangeEnd = useCallback((position) => {
    var _a;
    onChangeEnd == null ? void 0 : onChangeEnd({ min: getValueFromPosition(position, min, max, width), max: (_a = currentValue == null ? void 0 : currentValue.max) != null ? _a : max });
  }, [currentValue, min, max, width, onChangeEnd]);
  const onMaxChangeEnd = useCallback((position) => {
    var _a;
    onChangeEnd == null ? void 0 : onChangeEnd({ min: (_a = currentValue == null ? void 0 : currentValue.min) != null ? _a : min, max: getValueFromPosition(position, min, max, width) });
  }, [currentValue, min, max, width, onChangeEnd]);
  const minPosition = useMemo(() => getPositionFromValue(min, min, max, width), [min, max, width]);
  const maxPosition = useMemo(() => getPositionFromValue(max, min, max, width), [min, max, width]);
  return {
    positions,
    minPosition,
    maxPosition,
    updateMinFromPosition,
    updateMaxFromPosition,
    onMinChangeEnd,
    onMaxChangeEnd
  };
};

export { useSlider };
//# sourceMappingURL=useSlider.es.js.map
